import { useTranslation } from 'react-i18next';

import ContactForm from '../Contact/ContactForm';

export const WidgetRequest = () => {
  const { t } = useTranslation();

  return (
    <ContactForm
      type={`WIDGET`}
      placeholder={t('widgetRequest.placeholder')}
      title={t('widgetRequest.title')}
      subtitle={t('widgetRequest.subtitle')}
    />
  );
};
